/**
 * Parses `[Evidence: Strong|Moderate|Limited|Consensus]` tokens from clinical
 * markdown. Tokens are stripped from display text; strength drives EvidenceBadge.
 * Web --foreground ≈ PDF #0F172A; consensus green ≈ #059669.
 */
const EVIDENCE_TOKEN_RE =
  /\[Evidence:\s*(Strong|Moderate|Limited|Consensus)\]/gi;

export const EVIDENCE_VARIANTS = ["strong", "moderate", "limited", "consensus"];

export function parseEvidenceToken(text) {
  if (!text) return null;
  const match = String(text).match(/\[Evidence:\s*(Strong|Moderate|Limited|Consensus)\]/i);
  if (!match) return null;
  return match[1].toLowerCase();
}

export function stripEvidenceTokens(text) {
  if (!text) return "";
  return String(text).replace(EVIDENCE_TOKEN_RE, "").trim();
}

export function stripEvidenceFromMarkdown(markdown) {
  if (!markdown) return "";
  return String(markdown).replace(EVIDENCE_TOKEN_RE, "");
}
